<template>
  <div>
    <div v-if="individualReserveData.length===0" style="margin: 10px">
      还没有任何个人预约
    </div>
    <div v-if="groupReserveData.length===0" style="margin: 10px">
      还没有任何团体预约
    </div>
    <!--      绑定开始-->
    <div v-if="bindInfo.bindType!==undefined">
      <div v-if="bindInfo.bindType==='Student'">
        <el-tag type="success">已绑定学号姓名：{{ bindInfo.name }} {{ bindInfo.xh }}</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
        <div>
          <div v-if="bindInfo.phone===''||bindInfo.phone===null">
            <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">绑定联系方式</el-button>
          </div>
          <div v-else-if="bindInfo.phone!==''&&bindInfo.phone!==null">
            <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">更改联系方式</el-button>
          </div>
        </div>
      </div>
      <div v-if="bindInfo.bindType==='None'">
        <el-tag type="danger">未绑定学号姓名，无法选座</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/bindXh')">前往绑定（学生）</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/BindTeacher')">前往绑定（教职工）</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendFrom')">从已认证的手机同步身份</el-button>
      </div>
      <div v-if="bindInfo.bindType==='TeacherVerified'">
        <el-tag type="success">已绑定且已认证：{{ bindInfo.name }} {{ bindInfo.affiliation }}</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendTo')">同步身份到另一台手机</el-button>
        <div>
          <div v-if="bindInfo.phone===''||bindInfo.phone===null">
            <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">绑定联系方式</el-button>
          </div>
          <div v-else-if="bindInfo.phone!==''&&bindInfo.phone!==null">
            <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">更改联系方式</el-button>
          </div>
        </div>
      </div>
      <div v-if="bindInfo.bindType==='TeacherUnverified'">
        <el-tag type="warning">已绑定但未认证：{{ bindInfo.name }} {{ bindInfo.affiliation }}</el-tag>
        <el-tag type="warning">请首次前往时携带工作证以备查验</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendTo')">同步身份到另一台手机</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/VerifyTeacher')">认证</el-button>
        <div>
          <div v-if="bindInfo.phone===''||bindInfo.phone===null">
            <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">绑定联系方式</el-button>
          </div>
          <div v-else-if="bindInfo.phone!==''&&bindInfo.phone!==null">
            <el-button style="margin: 5px" type="mini" @click="$router.push('/BindPhoneNumber')">更改联系方式</el-button>
          </div>
        </div>
      </div>

    </div>
    <!--      绑定结束-->


    <el-card class="card" v-for="item of individualReserveData" shadow="hover">
      <div slot="header" class="clearfix">
        <span>个人预约</span>

        <el-popover
            v-model="item.deleteMenuVisible">
          <p>确定取消该个人预约吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="item.deleteMenuVisible = false">取消</el-button>
            <el-button type="primary" size="mini"
                       @click="item.deleteMenuVisible = false;doCancelIndividualReserve(item.uuid)">确定
            </el-button>
          </div>
          <el-button type="text" slot="reference" style="float: right; padding: 3px 0;"
                     @click="cancelIndividualReserve">取消预约
          </el-button>
        </el-popover>

      </div>

      <span>
         {{ parseByKey(item.room).name }}
        <br>
         <span v-if="item.room==='mensetu'">面试室</span><span v-else>座位</span>：{{ item.Seat }}
      <br>
        时间段：{{ item.Period + " " + parsePeriod(item.Period) }}
       </span>


    </el-card>


    <el-card class="card" v-for="item of groupReserveData" shadow="hover">
      <div slot="header" class="clearfix">
        <span>团体预约</span>

        <el-popover

            v-model="item.deleteMenuVisible">
          <p>确定取消该团体预约吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="item.deleteMenuVisible = false">取消</el-button>
            <el-button type="primary" size="mini"
                       @click="item.deleteMenuVisible = false;doCancelGroupReserve(item.uuid)">确定
            </el-button>
          </div>
          <el-button type="text" slot="reference" style="float: right; padding: 3px 0;"
                     @click="cancelIndividualReserve">取消团体预约
          </el-button>
        </el-popover>

      </div>

      <span>
        活动名称: {{ item.Huodongmingcheng }}
        <br>
         参加人: {{ item.Canjiaren }}
        <br>
        联系单位/团队: {{ item.Lianxidanweituandui }}
        <br>
        联系电话: {{ item.Lianxidianhua }}
        <br>
        联系人：{{ item.Lianxiren }}
        <br><br>
        开始时间:{{ item.StartTime }}
        <br>
        结束时间: {{ item.EndTime }}


       </span>


    </el-card>
  </div>


</template>

<script>
import axios from '@/utils/request'
import {parseByKey} from "@/utils/roomsAdapter";
import {parsePeriod} from "@/utils/WeekParser";

export default {
  name: 'Home',
  data() {
    return {
      individualReserveData: [],
      groupReserveData: [],
      bindInfo: {}
    }
  },
  methods: {
    parsePeriod(p) {
      return parsePeriod(p)
    },
    parseByKey(key) {
      return parseByKey(key)
    },
    getIndividual() {
      axios.post("/GetMySelectedSeat",{
        roomKey:this.$store.state.nowRoom.key
      }).then(res => {
        console.log(res);
        if (res.data.MySelectedSeats)
          for (let item of res.data.MySelectedSeats) {
            item.deleteMenuVisible = false
          }
        this.individualReserveData = res.data.MySelectedSeats === undefined ? [] : res.data.MySelectedSeats
      })
    },
    getGroup() {
      axios.post("/getMyGroupReserved", {Platform: "Web"}).then(res => {
        console.log(res);
        if (res.data.MySelectedSeats)
          for (let item of res.data.array) {
            item.deleteMenuVisible = false
          }

        this.groupReserveData = res.data.array === undefined ? [] : res.data.array
      })
    },
    cancelIndividualReserve(item) {
      item.deleteMenuVisible = true

    },
    doCancelIndividualReserve(uuid) {
      axios.post("/Leave", {uuid}).then(() => {
        this.getIndividual()
      })

    },
    doCancelGroupReserve(uuid) {
      axios.post("/deleteGroupReserve", {uuid}).then(() => {
        this.getGroup()
      })
    },
    getBindInfo() {
      axios.post("/getBindInfo").then(res => {
        this.bindInfo = res.data.bindInfo
      })
    },
  },
  mounted() {
    this.getBindInfo()
  },
  created() {
    this.getIndividual()
    this.getGroup()
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
